import Cache from './Cache';

export default class AuthState extends Cache {
  constructor() {
    super('authStatus');
  }
}
